import { Modal, Collapse, Tag, Empty, Divider } from "antd";

const ProofCheckModalView = ({ open, proof, ticker, onClose }) => {
    // 处理 proof 数据
    const proofOfWork = proof?.proofOfWork ?? [];

    // 构建 Collapse 的 items
    const collapseItems = proofOfWork.map((item, index) => ({
        key: item.id || index,
        label: (
            <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                <Tag color="blue">ID: {item.id}</Tag>
                {item.type && <Tag>Type: {String(item.type).toUpperCase()}</Tag>}
                <span style={{ fontWeight: 500 }}>{item.title}</span>
            </div>
        ),
        children: (
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
                <div>
                    <div style={{ fontWeight: 500, marginBottom: 4, color: '#666' }}>Highlight:</div>
                    <div style={{
                        background: '#f5f5f5',
                        padding: 8,
                        borderRadius: 4,
                        fontSize: 12,
                        color: '#0260FF'
                    }}>
                        {item.highlight || '-'}
                    </div>
                </div>
                <Divider style={{ margin: '4px 0' }} />
                <div>
                    <div style={{ fontWeight: 500, marginBottom: 4, color: '#666' }}>Content:</div>
                    <div style={{
                        background: '#f5f5f5',
                        padding: 12,
                        borderRadius: 4,
                        lineHeight: 1.2,
                        whiteSpace: 'pre-wrap',
                        wordBreak: 'break-word'
                    }}>
                        {item.content}
                    </div>
                </div>
            </div>
        ),
    }));

    // 默认打开所有面板
    const defaultActiveKeys = proofOfWork.map((item, index) => item.id || index);

    return (
        <Modal
            title={`${ticker}: Proof of Work`}
            open={open}
            onCancel={onClose}
            footer={null}
            width={700}
            bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        >
            {proofOfWork.length > 0 ? (
                <Collapse items={collapseItems} defaultActiveKey={defaultActiveKeys} />
            ) : (
                <Empty description="No Proof of Work" />
            )}
        </Modal>
    );
};

export default ProofCheckModalView;

